"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios = require("axios");
var sdk_1 = require("./sdk");
var Client = /** @class */ (function () {
    function Client() {
    }
    Client.get = function (resource, params) {
        var url = this.apiUrl + "/" + resource;
        var config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };
        if (typeof params === 'string')
            url += "/" + params;
        else
            url += "?" + this.paramsToQuery(params);
        return axios.default.get(url, config)
            .then(function (response) {
            return response.data[Object.keys(response.data)[0]];
        });
    };
    Client.paramsToQuery = function (params) {
        var query = '';
        if (params) {
            params.map(function (q) {
                query += (q.name + "=" + encodeURIComponent(q.value.toString())).concat('&');
            });
        }
        return query;
    };
    Client.apiUrl = sdk_1.API_URL + "/v" + sdk_1.API_VERSION;
    return Client;
}());
exports.Client = Client;
//# sourceMappingURL=client.js.map